<template>
  <div style="display: flex; justify-content: space-between;align-items: center">
    <cargo-user-select
      :disabled="disabled"
      :default-value="job.sales"
      style="flex:1"
      v-bind="$attrs"
      v-on="$listeners"
      @change="onSalesChange"
    />&nbsp;
    <el-checkbox v-model="job.provisioned" :disabled="true" style="margin-left: 5px" @change="onChange('provisioned')">{{ $t('SeaExport.Accrued') }}</el-checkbox>
  </div>
</template>

<script>
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'

export default {
  name: 'SeSales',
  components: { cargoUserSelect },
  props: {
    job: { type: Object, default: () => { return {} } },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    onSalesChange(data) {
      this.job.sales = data.value
      this.$emit('childrenChange', [{ key: 'sales', value: this.job.sales }])
    },
    onChange(key) {
      this.$emit('childrenChange', [{ key, value: this.job[key] }])
    }
  }
}
</script>
